export default __webpack_public_path__ + "static/media/alvin.1f74bec6.jpg";